export class UnitAddress {
  /** First line of an address. */
  public street: string;

  /** Optional. Second line of an address.*/
  public street2: string;

  /** City */
  public city: string;

  /** Two letters representing the state. Only required for US addresses. */
  public state: string;

  /** Postal code. */
  public postalCode: string;

  /** Two letters representing the country. */
  public country: string;
}
